/**
 * @author Fabrizio Giordano (Fab77)
 * Enum for coordinate types.
 * @readonly
 * @enum {{name: string, hex: string}}
 */

export enum CoordsType {
  CARTESIAN = "cartesian",
  SPHERICAL = "spherical",
  ASTRO = "astro"
}
